const normalizeStatusGroup = (statusGroup) => statusGroup
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
export const getNewestCardTrackingEvent = (events) => events.reduce((newestEvent, event) => {
    if (!newestEvent) {
        return event;
    }
    return new Date(event.occurredAt).getTime() > new Date(newestEvent.occurredAt).getTime() ? event : newestEvent;
}, undefined);
export const sortCardTrackingEventsNewestFirst = (events) => [...events].sort((left, right) => new Date(right.occurredAt).getTime() - new Date(left.occurredAt).getTime());
export const mapCardTrackingDetailStatus = (events) => {
    const newestEvent = getNewestCardTrackingEvent(events);
    if (!newestEvent) {
        return 'CREATED';
    }
    const statusGroup = normalizeStatusGroup(newestEvent.trackingStatusGroupName);
    if (statusGroup === 'entregue' || statusGroup === 'delivered') {
        return 'DELIVERED';
    }
    if (statusGroup === 'cancelado' ||
        statusGroup === 'cancelled' ||
        statusGroup === 'devolvido' ||
        statusGroup === 'returned') {
        return 'CANCELLED';
    }
    return 'IN_TRANSIT';
};
